import axiosInstance, { getApiBaseUrl } from './axiosInstance';
import { isInNativeTab } from '../utils/nativeTab';

export interface AuthUser {
  email: string | null;
  name: string | null;
  sid: string | null;
}

export interface AuthStatus {
  isAuthenticated: boolean;
  user: AuthUser | null;
}

class AuthService {
  async getAuthStatus(): Promise<AuthStatus> {
    try {
      const response = await axiosInstance.get('/auth/me');
      const data = response.data;

      if (data.isAuthenticated) {
        return {
          isAuthenticated: true,
          user: {
            email: data.email || null,
            name: data.name || null,
            sid: data.sid || null,
          },
        };
      }

      return { isAuthenticated: false, user: null };
    } catch (error) {
      console.error('[AuthService] Failed to get auth status:', error);
      return { isAuthenticated: false, user: null };
    }
  }

  signIn(returnUrl?: string): void {
    const apiBase = getApiBaseUrl();
    const target = returnUrl || window.location.pathname + window.location.search;
    const nativeTabParam = isInNativeTab() ? '&nativeTab=true' : '';
    window.location.href = `${apiBase}/auth/login?returnUrl=${encodeURIComponent(target)}${nativeTabParam}`;
  }

  signOut(): void {
    const apiBase = getApiBaseUrl();
    window.location.href = `${apiBase}/auth/logout`;
  }
}

export const authService = new AuthService();
